import {
  FopiCurrenciesDtoResponse,
  FopiFundsDtoResponse,
  FopiFundShareClassesDtoResponse,
  FopiFundShareClassRequestDto,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { portalGatewayClient } from '../portalGatewayClient';

export const fetchFopiFundsData: QueryFunction<
  FopiFundsDtoResponse
> = async () => {
  try {
    const response = await portalGatewayClient.fopi.searchFopiFunds();

    if (response.ok) {
      return response.data;
    }

    throw new Error('Fetching fund operation funds failed.');
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};

export const fetchFopiCurrenciesData: QueryFunction<
  FopiCurrenciesDtoResponse,
  readonly [string, string | undefined]
> = async ({ queryKey }) => {
  const [, fundId] = queryKey;

  try {
    const response = await portalGatewayClient.fopi.searchFopiCurrencies(
      undefined,
      { selection: fundId ? { fundId } : {} }
    );

    if (response.ok) {
      return response.data;
    }

    throw new Error('Fetching fund operation currency failed.');
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};

export const fetchFopiFundShareClassesData: QueryFunction<
  FopiFundShareClassesDtoResponse,
  readonly [string, requestData: FopiFundShareClassRequestDto]
> = async ({ queryKey }) => {
  const [, { selection }] = queryKey;

  try {
    const response = await portalGatewayClient.fopi.searchFopiFundShareClasses(
      undefined,
      { selection }
    );

    if (response.ok) {
      return response.data;
    }

    throw new Error('Fetching fund operation fund share classes failed.');
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
